const Immutable = require('immutable');

function defaultComparator(a, b, c) {
    return a > b ? 1 : b > a ? -1 : c ? c() : 0;
}

function comparisionDone(result) {
    return () => {
        return {
            thenCompare:comparisionDone(result),
            result:() => result
        }
    }
}

function compare(a, b, c) {
    if ( !c ) c= defaultComparator;

    let result = c(a,b);
    return {
        thenCompare:result === 0 ? compare : comparisionDone(result),
        result:() => result
    };

}

function toImmutable(obj) {
    return Immutable.fromJS(obj, (key, value) => {
        const isIndexed = Immutable.Iterable.isIndexed(value);
        return isIndexed ? value.toSet() : value.toMap();
    })
}

function removeFromLocalStorage(key) {
    // Ignore when testing for now
    if(!window.localStorage) {
        console.log("No localStorage. Ignoring")
        return;
    }
    window.localStorage.removeItem(key);
}
function fromLocalStorage(key) {
    // Ignore when testing for now
    if(!window.localStorage) {
        console.log("No localStorage. Ignoring")
        return;
    }
    try { return JSON.parse(window.localStorage.getItem(key))} catch (e) {
        window.localStorage.removeItem(key);
        return null
    }
}
function immutableToLocalStorage(key, immutable) {
    // Ignore when testing for now
    console.log('Saving  state: ', key, immutable);

    if(!window.localStorage) {
        console.log("No localStorage. Ignoring")
        return;
    }
    if ( Immutable.Iterable.isIterable(immutable) ) {
        window.localStorage.setItem(key, JSON.stringify(immutable.toJS()))
    } else {
        console.warn('Ignoring: ', key, immutable);

    }
}
module.exports.toImmutable = toImmutable;
module.exports.compare = compare;
module.exports.defaultComparator = defaultComparator;
module.exports.immutableToLocalStorage = immutableToLocalStorage;
module.exports.fromLocalStorage = fromLocalStorage;
module.exports.removeFromLocalStorage = removeFromLocalStorage;


// WEBPACK FOOTER //
// ./src/utils.js